import React from 'react';
import TableMaterial from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { DeclarationItems } from './DeclarationItems';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { apllicantData } from '../../../redux/actions/applicantAction';
import FilePreview from '../profile/FilePreview';
import { history } from '../../../utils/hist';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: '#2D5CA6',
    color: theme.palette.common.white,
    fontSize: 14,
    padding: '8px',
    fontFamily: 'proba_pro_semi_bold'
  },
  body: {
    fontSize: 14,
    paddingTop: 0,
    paddingBottom: 0
  }
}))(TableCell);

const DeclarationTable = props => {
  const [open, setOpen] = React.useState(false);
  const [filePreview, setFile] = React.useState({
    fileName: '',
    type: '',
    file: ''
  });
  const handleClickOpen = id => {
    const type = 'pdf';
    const file = `${id}.pdf`;

    setFile(prev => ({ fileName: `/fop/file/${file}`, type, file }));

    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setFile({
      fileName: '',
      type: '',
      file: ''
    });
  };

  const handleEdit = async id => {
    // try {
    //   await props.apllicantData(id);
    //   history.push('/profile-page/edit');
    // } catch (error) {

    // }

    props
      .apllicantData(id)
      .then(res => {
        history.push('/profile-page/edit');
      })
      .catch(err => {
        // history.push('/profile-page');
      });
    //  setTimeout(() => {
    //   history.push('/profile-page/edit');
    //  }, 100);
  };
  return (
    <>
      <TableMaterial>
        <TableHead>
          <TableRow>
            <StyledTableCell rowSpan="2">№з.п</StyledTableCell>
            <StyledTableCell rowSpan="2">Номер заяви</StyledTableCell>
            <StyledTableCell rowSpan="2">Стан заяви</StyledTableCell>
            <StyledTableCell rowSpan="2">Дата подачі заяви</StyledTableCell>
            <StyledTableCell rowSpan="2">Редагувати</StyledTableCell>
            <StyledTableCell rowSpan="2">Перегляд/Друк заяви</StyledTableCell>
            <StyledTableCell colSpan="5" className="text-center">
              Результат
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>Відпрацювання заяви</StyledTableCell>
            <StyledTableCell>Розмір допомоги</StyledTableCell>
            <StyledTableCell>Кількість дітей</StyledTableCell>
            <StyledTableCell>Дата „з”</StyledTableCell>
            <StyledTableCell>Дата „по”</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.applications.map((item, index) => (
            <DeclarationItems
              handleClickOpen={handleClickOpen}
              apllicantData={handleEdit}
              item={item}
              key={item.id}
              index={index}
            />
          ))}
        </TableBody>
      </TableMaterial>
      <FilePreview
        open={open}
        onClose={handleClose}
        filePreview={filePreview}
      />
    </>
  );
};

const mapStateToProps = state => ({
  applications: state.application.applications
});

export default connect(mapStateToProps, { apllicantData })(DeclarationTable);
